import React from 'react';
interface TimelineItem {
  week: string;
  text: string;
}
interface TimelineProps {
  items: TimelineItem[];
}
export function Timeline({
  items
}: TimelineProps) {
  return <ul className="my-7 mb-9 p-0 list-none" data-id="element-41">
      {items.map((item, index) => <li key={index} className={`py-3.5 pl-8 relative text-[clamp(16px,2vw,18px)] text-[#111111] leading-[1.65] font-lora ${index !== items.length - 1 ? 'border-b border-border' : ''}`} data-id="element-42">
          <div className="absolute left-0 top-[22px] w-2.5 h-2.5 rounded-full bg-teal" data-id="element-43"></div>
          <span className="font-inter text-[11px] font-bold tracking-[0.12em] uppercase text-teal block mb-1" data-id="element-44">
            {item.week}
          </span>
          {item.text}
        </li>)}
    </ul>;
}